import { AlphaNBoxOutlineIcon } from './AlphaNBoxOutlineIcon';

/**
 * author: Contributors
 * id DF0B3005-5E38-4E53-9025-981EFA45D8FD
 * name alpha-n-box-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-n-box-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetNBoxOutlineIcon = AlphaNBoxOutlineIcon;
export default AlphabetNBoxOutlineIcon